import { UntitledIcon } from '@faceup/icons'
import { usAttachment02 } from '@faceup/icons/usAttachment02'
import { Button, Space, Typography } from '@faceup/ui-base'
import { ucDropzone } from '../customIcons'
import Dropzone, { type DropzoneProps } from './Dropzone'

const { Text } = Typography

type ModifiedDropzoneProps = Omit<DropzoneProps, 'style' | 'children' | 'disabled'>

type AttachmentDropzoneProps = {
  translations: {
    dropzoneOpen: string
    dropzoneDrop: string
    dropzoneLimits: string
    add: string
  }
} & ModifiedDropzoneProps

const AttachmentDropzone = (props: AttachmentDropzoneProps) => (
  <Dropzone
    translations={props.translations}
    disabled={false}
    attachments={props.attachments}
    setAttachments={props.setAttachments}
  >
    {(open, isMobile) =>
      isMobile ? (
        <Button onClick={open}>
          <Space align='center'>
            <UntitledIcon icon={usAttachment02} className='flex text-[22px] text-white' />
            {props.translations.add}
          </Space>
        </Button>
      ) : (
        <div className='flex flex-col items-center justify-center rounded-md border-2 border-colorBorder border-dashed p-6'>
          <UntitledIcon icon={ucDropzone} className='mb-4 text-4xl text-colorTextTertiary' />
          <Text style={{ textAlign: 'center' }}>
            <Button type='link' size='small' onClick={open}>
              {props.translations.dropzoneOpen}
            </Button>{' '}
            {props.translations.dropzoneDrop}
          </Text>
          <Text type='secondary' className='text-xs'>
            {props.translations.dropzoneLimits}
          </Text>
        </div>
      )
    }
  </Dropzone>
)

export default AttachmentDropzone
